module.exports = __webpack_public_path__ + "static/media/Background3.02858d7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Backgrounds/Background3.png
// module id = 254
// module chunks = 0